import React, { memo, useMemo } from "react";
import style from "../woundAssessment.module.scss";
import { fullMonthFormatDate, timeAgo } from "../../../../utils";

const WoundAssessmentCard = ({ assessment, modalOpen }) => {

  const { photoTakenBy, identifiedDate, assessedBy, lastAssessedDate, signedBy, lockedBy, reEvalSequence, id, title } = assessment || {};

  const photoTakenOn = useMemo(() => (identifiedDate ? fullMonthFormatDate(identifiedDate) : "NA"), [identifiedDate]);

  const lastAssessed = useMemo(() => (lastAssessedDate ? timeAgo(lastAssessedDate) : "NA"), [lastAssessedDate]);

  const showAllAssessments = useMemo(() => reEvalSequence > 0, [reEvalSequence]);

  const unableToAssessWound = !!assessment?.refusalReason;

  return (
    <div className="row">
      <div className="col-12">
        <div className={`row align-items-center ${style.assess_content_subDetails}`}>
          <div className="col-9 pr-0">
            <div className={`${style.assess_content} mb-2 pt-1`}>
              <span className={style.assess_label_subDetail_label}>{unableToAssessWound ? "Documented by:" : "Photo taken by:"}</span>{" "}
              <span className={style.assess_label_subDetail_labelout}>{photoTakenBy ?? "NA"}</span>
              {" | "}
              <span className={style.assess_label_subDetail_label}>{unableToAssessWound ? "Documented on:" : "Photo taken on:"}</span>{" "}
              <span className={style.assess_label_subDetail_labelout}>{photoTakenOn}</span>
            </div>

            <div className={`${style.assess_content} mb-2`}>
              <span className={style.assess_label_subDetail_label}>Assessed by:</span>{" "}
              <span className={style.assess_label_subDetail_labelout}>{assessedBy ?? "NA"}</span>
              {" | "}
              <span className={style.assess_label_subDetail_label}>Last assessed:</span>{" "}
              <span className={style.assess_label_subDetail_labelout}>{lastAssessed}</span>
            </div>

            <div className={`${style.assess_content} mb-1`}>
              <span className={style.assess_label_subDetail_label}>Signed:</span>{" "}
              <span className={style.assess_label_subDetail_labelout}>{signedBy ?? "NA"}</span>
              {" | "}
              <span className={style.assess_label_subDetail_label}>Reviewed & Locked:</span>{" "}
              <span className={style.assess_label_subDetail_labelout}>{lockedBy ?? "NA"}</span>
            </div>
          </div>

          {showAllAssessments && (
            <div className="col-3">
              <div className="row align-items-center">
                <div className={style.assement_all_link}>
                  <button className={`btn ${style.assess_link}`} onClick={() => modalOpen(id, title)}>
                    All assessments
                    <span className={style.right_Arrow}>
                      <i className="fa-solid fa-circle-right" aria-hidden="true" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(WoundAssessmentCard);
